import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { ApplicationsIdSchema } from '../applications.schema';
import {
  ActivityTrendQuerySchema,
  ActivityTrendResponseSchema,
} from './activity-trend.schema';

export const activityTrendContractRoutes = {
  getApplicationActivityTrend: terraContract
    .meta({
      permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
    })
    .route({
      method: 'GET',
      path: '/{id}/activity-trend',
      summary: 'Get findings, signals and Neo executions created over time',
      description:
        'Returns bucketed counts of published findings, signals and Neo executions created in the requested window for one application.',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        query: ActivityTrendQuerySchema,
      }),
    )
    .output(ActivityTrendResponseSchema),
};
